import { axiosInstance } from '@/modules/shared/lib/axios'
import { BonusConfigurationUpdateInput } from './types'

export function updateBonusConfiguration({ companyId, payload }: BonusConfigurationUpdateInput) {
  return axiosInstance.post<boolean>(
    `/api/${companyId}/timesheet/saveBonusConfiguration`,
    payload,
  )
}
